<template>
    <div class="uk-padding-small ">
        <div class="uk-container uk-container-small">
            <h3 class="uk-text-muted uk-text-center" style="font-variant: all-small-caps; ">Already trusted by: </h3>
            <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slider="autoplay: true; autoplay-interval: 1500">

                <ul class="uk-slider-items uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-5@m" >
                    <li><img class="uk-align-center" src="/ncu_logo.png" style="max-width: 100px; max-height: 100px; width: auto; height: auto; margin-top: 5px" alt=""></li>
                    <li><img class="uk-align-center" src="/ecc_logo.png" style="max-width: 130px; max-height: 130px; width: auto; height: auto;" alt=""></li>
                    <li><img class="uk-align-center" src="/emc_logo.png" style="max-width: 130px; max-height: 130px; width: auto; height: auto; margin-top: -5px" alt=""></li>
                    <li><img class="uk-align-center" src="/CMU.jpg" style="max-width: 70px; max-height: 70px; width: auto; height: auto; margin-top: 15px" alt=""></li>
                    <li><img class="uk-align-center" src="/UCC_logo.png" style="max-width: 90px; max-height: 90px; width: auto; height: auto; " alt=""></li>
                    <li><img class="uk-align-center" src="/mico.jpg" style="max-width: 90px; max-height: 90px; width: auto; height: auto; " alt=""></li>

                </ul>

                <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
                <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next"></a>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "customers"
    }
</script>

<style scoped>

</style>